module.exports = __webpack_public_path__ + "images/Back677804e3413463cc056db4c08f5472e1.png";